import React, { PropTypes } from 'react';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
import './ImageUploader.scss';
import { alert } from 'util/alert';
import ImageCropper from 'template/Modals/ImageCropper';
import logoUploader from 'controllers/uploader/logoUploader';
import { Line } from 'rc-progress';
import _ from 'lodash'

const pica = require('pica/dist/pica.min.js')();

const ACCEPT_MIME = 'image/png,image/jpeg';
const MAX_SIZE = 5 * 1000 * 1000;
const MIN_SIZE = 0;
const DO_RESIZING = true;
const RESIZE_WIDTH = 300;
const RESIZE_HEIGHT = 300;

export function imageuploader (props) {
  const {
    options,
    value,
    onChange,
    required,
  } = props;

  return (
    <ImageUploader
      required={required}
      value={value}
      onChange={onChange}
      {...options}
    />
  );
}

class ImageUploader extends React.Component {
  constructor(props) {
    super(props);

    this.onDrop = this.onDrop.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.resizeImage = this.resizeImage.bind(this);

    this.state = {
      existingImg: props.value,
      lastUpdated: null,
      uploading: false,
    }
  }

  componentWillReceiveProps({ value }) {
    if (value) {
      this.setState({
        existingImg: value,
      });
    }
  }

  onDrop(accepted, rejected) {
    if (rejected.length > 0) {
      alert.warning(__('Image file must be png/jpeg under 5 MB', 'image'), __('Image not qualified', 'image'));
    } else if (accepted.length > 0) {
      // STEP 1. Open up modal
      ImageCropper({
        file: accepted[0],
        aspectRatioHeight: 1,
        aspectRatioWidth: 1,
      })
        .then(({ file, imageUrl, dataUrl })=>{
          // STEP 2. Modal returns a file and a temporary imageUrl which we apply
          // to the image preview
          if (file) {
            this.setState({
              existingImg: imageUrl,
            });
            // Step 3. Resize (or not) image before uploading
            const {
              doResizing = DO_RESIZING,
              options,
              onChange,
            } = this.props;

            if (doResizing == true) {
              const {
                resizeWidth = RESIZE_WIDTH,
                resizeHeight = RESIZE_HEIGHT,
              } = this.props

              this.resizeImage(dataUrl, resizeWidth, resizeHeight, (file)=>{
                this.uploadImage(file);
              });
            } else {
              this.uploadImage(file);
            }
          }
        })
        .catch((err)=>{
          console.error(err);
        });
    }
  }

  resizeImage(dataUrl, newWidth, newHeight, cb) {
    let from = document.createElement('img');
    from.src = dataUrl;

    from.onload = ()=>{
      let to = document.createElement('canvas');
      to.width = newWidth;
      to.height = newHeight;

      pica.resize(from, to)
        .then(result=>pica.toBlob(result, 'image/jpeg', 0.90))
        .then((resized)=>{
          cb(resized);
        })
        .catch((err)=>{
          cb(null)
          console.error(err);
        });

    }
  }

  uploadImage(file) {
    const schoolId = localStorage.getItem('schoolId');

    logoUploader(schoolId, file, ({ratio})=>{
      this.setState({
        uploading: true,
        ratio: parseInt(ratio * 100),
      });
    })
    .then((data)=>{
      // Step 4. UPload successful
      this.setState({
        uploading: false,
      }, ()=>{
        // Step 5. Update the image url
        this.props.onChange(data.save_to, file);
      });
    })
    .catch((err)=>{
      // TODO: create a more comprehensive error messgae
      console.error(err);
    });
  }

  render() {
    const {
      name,
      value,
      onChange,
      required,

      accept = ACCEPT_MIME,
      maxSize = MAX_SIZE,
      minSize = MIN_SIZE,
    } = this.props

    const {
      existingImg,
      lastUpdated,
      uploading,
      ratio,
    } = this.state;

    let variance = '';
    if (lastUpdated) {
      variance = '?lastupdated=' + lastUpdated;
    }

    return (
      <div className='imageuploader-wrapper form-input'>
        <Dropzone
          accept={accept}
          multiple={false}
          className='zone'
          maxSize={maxSize}
          minSize={minSize}
          onDrop={this.onDrop}
          children={(
            <div className={classnames(existingImg ? 'has-image' : 'has-no-image')}>
              { uploading != true &&
                <div className='overlay'>
                  <div className='text'>
                  {__('Click or drag and drop image here', 'schoolInformation.form')}
                  </div>
                </div>
              }
              {
                uploading == true &&
                <div className='upload-overlay'>
                  <Line percent={ratio} strokeWidth='5' trailWidth='5' />
                  <div>{ratio || 0}%</div>
                </div>
              }
              { !_.isEmpty(existingImg) && <img src={existingImg + variance} />}
            </div>
          )}
        />
      </div>
    );

  }
}

export default ImageUploader;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/ImageUploader/index.js